'use client';
// 共用元件 - 數量選擇（加減步進器）

import Image from 'next/image';
import { cn } from '@/common/util';

interface AmountSelectProps {
    // 目前數量
    value: number;
    // 數量變更
    onChange: (value: number) => void;
    // 最小值（預設 1）
    min?: number;
    // 最大值
    max?: number;
    // 每次增減的步進（預設 1）
    step?: number;
    // 外層額外樣式
    className?: string;
}

const AmountSelect = ({
    value,
    onChange,
    min = 1,
    max,
    step = 1,
    className,
}: AmountSelectProps) => {
    // 夾在 min ~ max 範圍內
    const clamp = (n: number) => {
        let next = n;
        if (next < min) next = min;
        if (max !== undefined && next > max) next = max;
        return next;
    };

    const decrease = () => onChange(clamp(value - step));
    const increase = () => onChange(clamp(value + step));

    const minusDisabled = value <= min;
    const plusDisabled = max !== undefined && value >= max;

    return (
        <div
            className={cn(
                'flex border border-black2 round [&>button]:w-11.5 [&_img]:mx-auto',
                className
            )}
        >
            <button
                type="button"
                onClick={decrease}
                disabled={minusDisabled}
                aria-label="減少"
                className="trans cp disabled:opacity-30 disabled:cursor-not-allowed"
            >
                <Image
                    src="/images/icon/icon_arrow.svg"
                    width={11}
                    height={10}
                    alt="icon"
                    className="rotate-180"
                />
            </button>

            <span className="w-22.5 text-center text-btn1 text-jblack py-2.5 border-x border-black2 tabular-nums">
                {value}
            </span>

            <button
                type="button"
                onClick={increase}
                disabled={plusDisabled}
                aria-label="增加"
                className="trans cp disabled:opacity-30 disabled:cursor-not-allowed"
            >
                <Image src="/images/icon/icon_arrow.svg" width={11} height={10} alt="icon" />
            </button>
        </div>
    );
};

export default AmountSelect;
